import React from 'react';
import 'antd/dist/reset.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './assets/scss/App.scss';

//imoprt Route
import RoutesComponents from './Routes/index';
import { ThemeProvider as CustomThemeProvider } from './Common/ThemeContext';

const App = () => {
    return (
        <CustomThemeProvider>
            <ToastContainer/>
            <RoutesComponents />
        </CustomThemeProvider>
    );
};

export default App;
